import { userStore } from '@stores/User';
import { useNavigate } from 'react-router';
import { AuthConsumeStatus } from '../AuthConsumeStatus';
import { useConsumeCode } from '../useConsumeCode';

export function ConfirmEmailPage() {
  const navigate = useNavigate();
  const { error } = useConsumeCode({
    consume: userStore.confirmEmail,
    missingCodeRedirect: '/',
    successRedirect: '/',
  });

  return (
    <AuthConsumeStatus
      error={error}
      loadingText="Confirming your email..."
      retryLabel="Resend verification email"
      onRetry={() => navigate('/verify-email')}
    />
  );
}
